export default "__VITE_ASSET__DDNWmHs7__"